export const GRID_COLORS = ["grid_blue", "grid_green", "grid_yellow"];